import { render, staticRenderFns } from "./AktivaJurnalForm.vue?vue&type=template&id=2fe54649&"
import script from "./AktivaJurnalForm.vue?vue&type=script&lang=js&"
export * from "./AktivaJurnalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports